<template>
  <div>
    <div class="sobre__union sobre__union--magoricon">
      <OQueFazemos />
      <div class="sobre__text sobre__text--position">
        <Section fill="#ffffff" background="#f5f5f5" inverted>
          <SobreText />
        </Section>
      </div>
    </div>
    <Section fill="#f5f5f5" background="#fff" inverted>
      <QuemJaPassouAqui />
    </Section>
    <Section fill="#ffffff" background="#f5f5f5" overflow>
      <BannerSobre />
    </Section>
  </div>
</template>

<script>
import OQueFazemos from "@/sections/OQueFazemos";
import BannerSobre from "@/sections/BannerSobre";
import SobreText from "@/sections/SobreText";
import Section from "@/components/Section";
import QuemJaPassouAqui from "@/sections/QuemJaPassouAqui";

export default {
  name: "sobre",
  components: {
    BannerSobre,
    Section,
    OQueFazemos,
    SobreText,
    QuemJaPassouAqui
  },
  head: {
    title: {
      inner: "Saiba mais sobre a agência. Por que trabalhar com a gente? "
    },

    meta: [
      {
        name: "description",
        content:
          "Entendemos cada negócio, meta e desafio que passam pela agência, e usamos ferramentas inteligentes para traçar uma estratégia de comunicação que funcione.",
        id: "desc"
      },
      {
        name: "og:description",
        content:
          "Entendemos cada negócio, meta e desafio que passam pela agência, e usamos ferramentas inteligentes para traçar uma estratégia de comunicação que funcione.",
        id: "ogdesc"
      },
      {
        name: "keywords",
        content:
          "magor, design, gráfico, digital, propaganda, marketing, talento"
      }
    ]
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/vars";
.sobre {
  &__union--magoricon {
    overflow: hidden;
  }
  &__text--position {
    margin-top: -28.5rem;
    @media (max-width: $max-sm) {
      margin-top: -5.7rem;
    }
  }
}
</style>
